import { createApp } from "vue";
import { createPinia } from "pinia";
import piniaPluginPersistedState from "pinia-plugin-persistedstate";
import AppMain from "./AppMain.vue";
import Router from "@/router";
import store from "@/store";
import toastr from "toastr";
import axios from "axios";
import VueAxios from "vue-axios";
import vSelect from "vue-select";

import "vue-select/dist/vue-select.css";
import ViewUIPlus from "view-ui-plus";
import "view-ui-plus/dist/styles/viewuiplus.css";
axios.defaults.withCredentials = true;

const penia = createPinia();
const app = createApp(AppMain);
penia.use(piniaPluginPersistedState);
app.component("v-select", vSelect);
app.use(ViewUIPlus);
app.use(VueAxios, axios);
app.use(Router);
app.use(toastr);
app.use(store);
app.use(penia);
app.use(vSelect);
app.mount("#app");
